/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import comm100 from '../configuration/Comm100';

class Chatbot {
  StartChatbot() {
    //COM100 Integration Starts
    comm100.map((data) => {
      //console.log(data.campaignId, 'data');
      const div1 = document.createElement('div');
      div1.id = 'comm100-button-' + data.campaignId;
      div1.class = 'jv-chat-bubble';
      //console.log(div1.id, 'div1.id ');
      document.body.appendChild(div1);
      const script = document.createElement('script');
      script.innerHTML =
        'var Comm100API=Comm100API||{};(function(t){function e(e){var a=document.createElement("script"),c=document.getElementsByTagName("script")[0];a.type="text/javascript",a.async=!0,a.src=e+t.site_id,c.parentNode.insertBefore(a,c)}t.chat_buttons=t.chat_buttons||[],t.chat_buttons.push({code_plan:' +
        data.campaignId +
        ',div_id:"comm100-button-' +
        data.campaignId +
        '"}),t.site_id= ' +
        data.instanceId +
        ',t.main_code_plan=' +
        data.campaignId +
        ',e("' +
        data.vueUrl +
        '"),setTimeout(function(){t.loaded||e("' +
        data.standbyUrl +
        '")},5e3)})(Comm100API||{})';
      document.body.appendChild(script);
    });

    //COM100 Integration Ends
  }
}

export default new Chatbot();
